import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import "./ForgotPasswordPage.css";
// import { loginUser } from "../../services/auth/AuthAPI";O
import { Form, Spin } from "antd";
import TranscribeLogo from "../../../assets/img/logo.png";
import WilliamColorLogo from "../../../assets/img/williams_lea.png";
import { forgotPassword, loginUser } from "../../../services/auth/AuthAPI";

function ForgotPasswordPage(props: any) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.clear();
  }, []);
  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      await forgotPassword(values.username);

      setLoading(false);
      navigate("/forgot-password-submit");
    } catch (error: any) {
      setError(error.message);
      setLoading(false);
    }
  };

  return (
    <div className="login-main-container container-fluid justify-content-center align-item-center overflow-auto">
      <Spin spinning={loading}>
        <div className="login-container">
          <div className="login-wrapper">
            <img
              className="mb-3"
              src={TranscribeLogo}
              alt="Transcribe"
            />

            <div className="forgot-password-title">Reset Password</div>
            <Form
              {...formItemLayout}
              onFinish={onFinish}
              colon={false}
              form={form}
              style={{ width: "100%" }}>
              <Form.Item
                label="Email"
                name={"username"}
                required={false}
                rules={[{ required: true, message: "Please input your username!" }]}
                labelAlign="left">
                <input
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Form>
            <div className="d-flex flex-column w-100">
              <span
                className="mb-3"
                style={{ color: "red", width: "100%" }}>
                {error}
              </span>
              <button
                className="button"
                style={{ justifySelf: "center", alignSelf: "center" }}
                onClick={() => form.submit()}>
                Send Code
              </button>
            </div>
            <div
              className="link my-3"
              onClick={() => navigate("/")}>
              Back to Sign in
            </div>

            <img
              className="mt-3"
              src={WilliamColorLogo}
              alt="Williams Lea"
            />
          </div>
        </div>
      </Spin>
    </div>
  );
}

export default ForgotPasswordPage;
